// @flow

import React from 'react';
import getConfig from 'next/config';
import { withRouter } from 'next/router';

import { SignupForm } from '@zapier/design-system-app-profiles';
import { useSignupData } from '@zapier/data';

import useSelectedApis from 'web-ssr/app/app-directory/hooks/useSelectedApis';

import type { RouterProps } from 'web-ssr/app/common/next/types';

const { publicRuntimeConfig } = getConfig();

type Props = {
  router: RouterProps,
  /** Size of the signup form to render */
  size: 'small' | 'medium' | 'large',
};

const SignupFormContainer = (props: Props) => {
  const { size, router } = props;

  const selectedApis = useSelectedApis({
    primaryAppSlug: router.query.primarySlug || router.query.slug,
    secondaryAppSlug: router.query.secondarySlug,
  });

  const {
    formData,
    formErrors,
    handleCaptchaExpiration,
    handleCaptchaVisible,
    handleCaptchaVerification,
    handleChange,
    handleFocus,
    handleGoogleOneTapError,
    handleGoogleOneTapSubmit,
    handleSubmit,
    hasTouched,
    isCaptchaRequired,
    isSubmitting,
    showGoogleOneTap,
    showSuccessMessage,
  } = useSignupData({
    selectedApis,
  });

  return (
    <SignupForm
      formData={formData}
      formErrors={formErrors}
      googleCaptchaSiteKey={publicRuntimeConfig.googleCaptchaSiteKey}
      googleClientId={publicRuntimeConfig.googleClientId}
      hasTouched={hasTouched}
      isCaptchaRequired={isCaptchaRequired}
      isSubmitting={isSubmitting}
      onCaptchaExpiration={handleCaptchaExpiration}
      onCaptchaVisible={handleCaptchaVisible}
      onChange={handleChange}
      onFocus={handleFocus}
      onGoogleAuthenticateError={handleGoogleOneTapError}
      onGoogleAuthenticateSuccess={handleGoogleOneTapSubmit}
      onSubmit={handleSubmit}
      onVerifyCaptcha={handleCaptchaVerification}
      selectedApis={selectedApis}
      showGoogleOneTap={showGoogleOneTap}
      showSuccessMessage={showSuccessMessage}
      size={size}
    />
  );
};

export default withRouter(SignupFormContainer);
